import { chain } from '@leprecoins/effector';
import { createEvent, EventCallable, is, StoreWritable } from 'effector';
import { createSourced, Sourced } from './create-sourced';

export type State<T> = {
	setValue: EventCallable<T>;
	$value: StoreWritable<T>;
	'@@unitShape': () => {
		setValue: EventCallable<T>;
		value: StoreWritable<T>;
	};
};

export const createState = <T>(value: Sourced<T>): State<T> => {
	const setValue = createEvent<T>();

	const $value = createSourced(value);

	chain(setValue, $value);

	return {
		setValue,
		$value,
		'@@unitShape': () => ({
			setValue,
			value: $value,
		}),
	};
};

export const isState = (value: unknown): value is State<unknown> =>
	value != null &&
	typeof value === 'object' &&
	'$value' in value &&
	is.store(value.$value) &&
	'targetable' in value.$value &&
	'setValue' in value &&
	is.event(value.setValue) &&
	'targetable' in value.setValue;
